import React from 'react';
import { Tag } from 'antd';
import type { TagProps } from 'antd';

export type AppTagProps = TagProps;

const AppTag = React.forwardRef<HTMLSpanElement, AppTagProps>((props, ref) => {
  return <Tag ref={ref} {...props} />;
});

AppTag.displayName = 'AppTag';

export default AppTag;
